// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7qaLb","comment":"styles_comment__2tuEh"};